<script setup>
const props = defineProps({
  title: { type: String, default: '' },
  artist: { type: String, default: '' },
  layout: { type: String, default: 'classic' }, // 'classic' | 'featured'
  align: { type: String, default: 'center' },   // 'start' | 'center' | 'end'
  max: { type: Number, default: 100 },          // soft truncate to avoid huge DOM text
});

function soft(text = '', n = 100){
  if (!text) return '';
  const s = String(text);
  return s.length > n ? s.substring(0, n) : s;
}
</script>

<template>
  <!-- CLASSIC: bold + truncate + optional muted artist -->
  <div v-if="layout==='classic'"
       class="amo-card-title classic d-inline-flex align-items-baseline justify-content-center"
       :class="{
         'text-start': align==='start' || align==='left',
         'text-center': align==='center',
         'text-end': align==='end' || align==='right',
       }"
  >
    <span class="font-bold text-truncate main" :title="title">{{ soft(title, max) }}</span>
  </div>

  <!-- FEATURED: bold under cover with featured-title styling -->
  <span v-else
        class="featured-title font-bold"
        :class="{
          'text-start': align==='start' || align==='left',
          'text-center': align==='center',
          'text-end': align==='end' || align==='right',
        }"
        :title="title"
  >{{ soft(title, max) }}</span>
</template>

<style scoped>
/* shared */
.amo-card-title { max-width: 100%; }

/* Classic style: one-line truncation like SoundCloud header */
.classic .main{
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 15px;
  line-height: 1.3;
}
.classic .artist{
  font-size: 12px;
  line-height: 1.2;
}

/* Ensure featured uses the app's existing .featured-title look */
.featured-title{
  font-size: 15px;
  line-height: 1.4;
  white-space: normal;
  word-wrap: break-word;
  overflow: hidden;
}
</style>
